import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

async function publicClient() {
  const key = process.env["SUPABASE_PUBLISHABLE_KEY"]!;
  const { createClient } = await import("@supabase/supabase-js");
  return createClient(process.env["SUPABASE_URL"]!, key, {
    auth: { persistSession: false, autoRefreshToken: false },
    global: {
      fetch: (input, init) => {
        const headers = new Headers(init?.headers);
        if (key.startsWith("sb_") && headers.get("Authorization") === `Bearer ${key}`) {
          headers.delete("Authorization");
        }
        headers.set("apikey", key);
        return fetch(input, { ...init, headers });
      },
    },
  });
}

export const listPublishedPosts = createServerFn({ method: "GET" }).handler(async () => {
  const { data, error } = await (await publicClient())
    .from("blog_posts")
    .select("slug, title, excerpt, image_url, image_alt, neighborhood, target_keyword, published_at")
    .eq("status", "published")
    .order("published_at", { ascending: false })
    .limit(60);

  if (error) {
    console.error("Erro ao listar posts:", error.message);
    return [];
  }
  return data ?? [];
});

export const getPublishedPost = createServerFn({ method: "GET" })
  .inputValidator((input: unknown) => z.object({ slug: z.string().min(1).max(200) }).parse(input))
  .handler(async ({ data }) => {
    const { data: post, error } = await (await publicClient())
      .from("blog_posts")
      .select(
        "slug, title, excerpt, content, image_url, image_alt, neighborhood, city, region, latitude, longitude, target_keyword, published_at, updated_at",
      )
      .eq("status", "published")
      .eq("slug", data.slug)
      .maybeSingle();

    if (error) {
      console.error("Erro ao buscar post:", error.message);
      return null;
    }
    return post;
  });
